<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title>
          RELAÇÃO DE DOCUMENTOS POR FRANQUEADO
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-alert type="success" v-if="successSave">
        <template v-slot:close>
          <v-icon @click="() => (successSave = false)"> mdi-close </v-icon>
        </template>
        Documentos Publicados com Sucesso
      </v-alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="5" lg="4">
              <v-autocomplete
                :items="companies"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="company"
                label="Franqueado"
                hide-details
                clearable
                dense
                outlined
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="months"
                v-model="month"
                label="Mês"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="years"
                v-model="year"
                label="Ano"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col class="py-1">
              <v-checkbox
                hide-details
                v-model="checkbox"
                label="Enviar E-mail"
              ></v-checkbox>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col class="py-1">
              <v-checkbox
                v-model="publication"
                hide-details
                label="Publicar Relatórios"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="2">
              <v-btn
                dark
                color="blue darken-3"
                small
                class="mt-1"
                @click="handleGenerateFiles()"
              >
                Gerar Relatórios
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-alert type="error" v-if="alertError">
                <template v-slot:close>
                  <v-icon @click="() => (alertError = false)">
                    mdi-close
                  </v-icon>
                </template>
                {{ alertMessage }}
              </v-alert>
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row v-if="files.files.length > 0" class="mb-6">
            <v-col cols="3">
              <v-simple-table>
                <thead>
                  <tr>
                    <th>Arquivos</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="file in files.files" :key="file.nome">
                    <td>{{ file.nome.replace("publications/", "") }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col cols="3">
              <v-row>
                <v-col class="d-flex justify-center">
                  <h3>Download ZIP</h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="d-flex justify-center">
                  <v-btn
                    dark
                    color="green darken-3"
                    class="mt-1"
                    large
                    target="_blank"
                    :href="download.link"
                  >
                    Download Arquivo
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>
<script>
import { URL } from "@/api/config";
import * as CompanyAPI from "@/api/requests/CompanyRequest";
export default {
  components: {},
  data: () => ({
    months: [
      { value: 1, text: "Janeiro" },
      { value: 2, text: "Fevereiro" },
      { value: 3, text: "Março" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Maio" },
      { value: 6, text: "Junho" },
      { value: 7, text: "Julho" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Setembro" },
      { value: 10, text: "Outubro" },
      { value: 11, text: "Novembro" },
      { value: 12, text: "Dezembro" },
    ],
    month: "",
    years: [],
    year: "",
    checkbox: false,
    publication: false,
    companies: [],
    billing_types: [
      { value: 1, text: "Normal" },
      { value: 2, text: "Retificação" },
    ],
    billing_type: 1,
    types_installment: [
      { value: 1, text: "Nº de Parcelas" },
      { value: 2, text: "Valor das Parcelas" },
    ],
    installment: 1,
    company: "",
    loading: false,
    successSave: false,
    lazy: false,
    valid: true,
    files: {
      files: [],
    },
    download: {
      link: "",
    },
    alertError: false,
    alertMessage: "",
  }),
  computed: {},
  created() {
    let dateNow = new Date();
    this.month = dateNow.getMonth() + 1;
    this.year = dateNow.getFullYear();
    let yearNow = dateNow.getFullYear();

    // COLOCA 10 ANOS PARA TRAS
    for (let i = 10; i >= 0; i--) {
      this.years.push(yearNow - i);
    }
    this.years = this.years.reverse();
    this.initialize();
  },
  methods: {
    async initialize() {
      this.getCompanies();
    },
    async getCompanies() {
      // this.loading = true;
      try {
        let data = await CompanyAPI.getAll("?type=fra,mul");
        this.companies = data.sort((a, b) => (a.code > b.code ? 1 : -1));
        this.companies.unshift({
          id: "",
          name: "FRANQUEADOS",
          code: "TODOS",
        });
      } catch (error) {
        this.companies = [];
        console.log(error);
      } finally {
        // this.loading = false;
      }
    },
    validate() {},
    async handleGenerateFiles() {
      this.files = {
        files: [],
      };
      this.download = {
        link: "",
      };
      this.alertError = false;
      this.loading = true;
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let res = await fetch(`${URL}download/invoice-documents`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({
            company: this.company,
            month: this.month,
            year: this.year,
            publication: this.publication,
          }),
        });
        let response = await res.json();
        if (res.ok) {
          this.files = response;
          this.download.link = `${URL}royalty/download/${response.zip.replace(
            "storage/",
            ""
          )}`;
        } else {
          console.log(response);
          this.alertError = true;
          this.alertMessage = response.error;
        }
        console.log(res);
      } catch (error) {
        console.log(error);
        this.alertError = true;
        this.alertMessage =
          "Erro ao gerar o arquivo zip, tente novamente mais tarde";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
